"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeteorFistAbilityHandler = exports.MeteorFistActorAbilityFactory = exports.MeteorFistAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const ActorType_1 = require("../../core/actors/ActorType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class MeteorFistAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MeteorFist;
        this.__typeName = "MeteorFist";
    }
}
exports.MeteorFistAbilityArgs = MeteorFistAbilityArgs;
let MeteorFistActorAbilityFactory = class MeteorFistActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MeteorFist", "AllEnemies", 2);
    }
};
MeteorFistActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MeteorFist")
], MeteorFistActorAbilityFactory);
exports.MeteorFistActorAbilityFactory = MeteorFistActorAbilityFactory;
let MeteorFistAbilityHandler = class MeteorFistAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const cinderDrakeIsAlive = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
            .some(other => container.getActor(other).classType === ActorType_1.ActorType.CinderDrake);
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        const abilityPower = cinderDrakeIsAlive ? 120
            : 150;
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targets: targets.map(targetId => ({
                jitter: (0, Random_1.random)(25, 75),
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Fire", abilityPower)
                ]
            }))
        });
    }
};
MeteorFistAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MeteorFist)
], MeteorFistAbilityHandler);
exports.MeteorFistAbilityHandler = MeteorFistAbilityHandler;
